import "../../../assets/css/clientsAdminView/editClient.css"
import countryInformation from "../../../assets/jsonData/countryInformation.json"

import goBack from "../../../assets/images/arrowForward.svg"
import deleteIcon from "../../../assets/images/delete.svg"
import moreDots from "../../../assets/images/moreDots.svg"
import addIcon from "../../../assets/images/add.svg"

import AddEntityModal from "../addEntity.jsx"
import EditEntityModal from "../editEntity.jsx"
import UsersControlModal from "../userControl.jsx"
import MassiveUploadModal from "../massiveUploadModal.jsx"
import AddClientUserModal from "../addClientUserModal.jsx"

import { Dropdown } from "react-bootstrap"
import { checkTheEmailStruct } from "../../../utilities/validateEmail.js"
import { useEditClient } from "../hooks/useEditClient.js"
import { ClientDocuments } from "./ClientDocuments.jsx"

export default function EditClient() {
    const {
        darkLightMode,
        
        draft,
        industries,
        isLoading,
        isSaving,
        moreDotsRef,
        addModalShow, setAddModalShow,
        editModalShow, setEditModalShow,
        entityToEdit,
        usersControlModal, setUsersControlModal,
        showMassiveUploadModal, setShowMassiveUploadModal,
        showUserModal, setShowUserModal,
        clientToAddUser,
        isAdminClient,
        havePurchasing,
        handleClientChange,
        handleContactInformationChange,
        handleAddContact,
        handleDeleteContact,
        handleDeleteEntities,
        handleShowEditModal,
        handleEditEntity,
        addCategory,
        addPurchasedModules,
        addPaymentWay,
        addCurrency,
        handleAddUserModal,
        handleSetEntities,
        checkEntitiesUrlName,
        handleEditClient,
        handleDeleteClient,
        toggleActiveClient,
        navigate,
    } = useEditClient()

    if (isLoading || !draft) return null

    const navigateToSuppliers = () => {
        navigate(`/home/suppliers/`, {
            state: { clientID: draft._id }
        })
    }

    return (
        <section className={`editClient ${darkLightMode ? "darkMode" : null}`}>
            <div className="titleAndBack">
                <img className="goBack" src={goBack} onClick={() => navigate(-1)} alt="Cattenna Platform" />
                <h3>{draft.generalInformation?.clientName}</h3>
            </div>
            
            <div className="clientQuickActions">
                <button 
                    className="btnBgBlueTextGradient" 
                    onClick={navigateToSuppliers}
                >
                    View suppliers
                </button>

                <button className="btnBgBlueTextGradient" onClick={toggleActiveClient}>
                    {draft.generalInformation?.clientActive ? "Disable client" : "Active client"}
                </button>

                <button className="btnBgBlueTextGradient" onClick={handleDeleteClient}>
                    Delete client
                </button>

                <button className="btnBgBlueTextGradient" onClick={() => setUsersControlModal(true)}>
                    Client credentials
                </button>

                <button className="btnBgBlueTextGradient" onClick={() => setShowMassiveUploadModal(true)}>
                    Massive upload
                </button>

                <button id="addUserButton" className="btnBgBlueTextGradient" onClick={() => handleAddUserModal(draft, true)}>
                    <img src={addIcon} alt="Prodensa Supplier" /> Add user
                </button>
            </div>

            <h5 className="titleHeader">Client Information</h5>

            <div className="inputSections">
                <div className="inputContainer">
                    <span className="label">Name</span>

                    <input 
                        type="text" 
                        placeholder="Client name" 
                        value={draft.generalInformation?.clientName}
                        onChange={(e) => handleClientChange("generalInformation", "clientName", e.target.value)}
                    />
                </div>
                
                <div className="inputContainer">
                    <span className="label">Industry</span>

                    <Dropdown>
                        <Dropdown.Toggle className={draft.generalInformation?.clientIndustries.length > 0 ? "" : "default"}>
                            {draft.generalInformation?.clientIndustries.length > 0
                                ? draft.generalInformation?.clientIndustries.map(category => category + ", ")
                                : "Industry"}
                        </Dropdown.Toggle>

                        <Dropdown.Menu>
                            {industries && industries.sort((a, b) => a.name.localeCompare(b.name)).map((industry, index) => {
                                if (industry.name !== "Global") {
                                    return (
                                        <div key={index} className="optionCategory">
                                            <input
                                                id={`categories${index}`}
                                                type="checkbox"
                                                defaultChecked={draft.generalInformation?.clientIndustries.some(cat => cat === industry.name.toUpperCase())}
                                                value={industry.name}
                                                onClick={(e) => addCategory(e.target)}
                                            />
                                            <label htmlFor={`categories${index}`}>{industry.name}</label>
                                        </div>
                                    )
                                }
                                return null
                            })}
                        </Dropdown.Menu>
                    </Dropdown>
                </div>

                <div className="inputContainer">
                    <span className="label">Active Modules</span>

                    <Dropdown>
                        <Dropdown.Toggle className={draft.generalInformation?.clientActiveModules.length > 0 ? "" : "default"}>
                            {draft.generalInformation?.clientActiveModules.length > 0
                                ? draft.generalInformation?.clientActiveModules.map(module => module + ", ")
                                : "Active Modules"}
                        </Dropdown.Toggle>

                        <Dropdown.Menu>
                            <div className="optionCategory">
                                <input 
                                    id="purchasing" 
                                    type="checkbox" 
                                    value="Purchasing" 
                                    onClick={(e) => addPurchasedModules(e.target)}
                                    defaultChecked={draft.generalInformation?.clientActiveModules.some(module => module === "PURCHASING")}
                                />

                                <label htmlFor="purchasing">Purchasing</label>
                            </div>
                        </Dropdown.Menu>
                    </Dropdown>
                </div>

                <div className="inputContainer calendar">
                    <span className="label">Active since</span>

                    <input 
                        value={draft.generalInformation?.clientActiveSince} 
                        type="date"
                        onChange={(e) => handleClientChange("generalInformation", "clientActiveSince", e.target.value)}
                    />
                </div>
                
                <div className="inputContainer calendar">
                    <span className="label">Renovation Date</span>

                    <input 
                        value={draft.generalInformation?.clientRenovationDate} 
                        type="date"
                        onChange={(e) => handleClientChange("generalInformation", "clientRenovationDate", e.target.value)}
                    />
                </div>
                
                <div className="inputContainer">
                    <span className="label">Commercial Name</span>

                    <input 
                        type="text" 
                        placeholder="Commercial Name" 
                        value={draft.generalInformation?.clientCommercialName}
                        onChange={(e) => handleClientChange("generalInformation", "clientCommercialName", e.target.value)}
                    />
                </div>
                
                <div className="inputContainer">
                    <span className="label">Signed Contract</span>

                    <input 
                        type="text" 
                        placeholder="Client PandaDoc URL" 
                        value={draft.generalInformation?.clientSignedContract}
                        onChange={(e) => handleClientChange("generalInformation", "clientSignedContract", e.target.value)}
                    />
                </div>
                
                <div className="inputContainer">
                    <span className="label">Notification contacts <bg-grey>(Separate by comma)</bg-grey></span>

                    <input 
                        value={draft.generalInformation?.clientNotificationContacts} 
                        type="text"
                        placeholder="example1@example.com, example2@example.com"
                        onChange={(e) => handleClientChange("generalInformation", "clientNotificationContacts", e.target.value)}
                    />
                </div>

                <h5 className="sectionTitle">Billing information</h5>

                <div className="inputContainer">
                    <span className="label">Company name</span>

                    <input 
                        type="text" 
                        placeholder="Company name" 
                        value={draft.billingInformation?.clientCompanyName}
                        onChange={(e) => handleClientChange("billingInformation", "clientCompanyName", e.target.value)}
                    />
                </div>
                
                <div className="inputContainer">
                    <span className="label">Tax regime</span>
                    
                    <Dropdown>
                        <Dropdown.Toggle className={draft.billingInformation?.clientTaxRegime ? "" : "default"}>
                            {draft.billingInformation?.clientTaxRegime ? draft.billingInformation?.clientTaxRegime : "Select option"}
                        </Dropdown.Toggle>

                        <Dropdown.Menu>
                            <Dropdown.Item onClick={(e) => handleClientChange("billingInformation", "clientTaxRegime", e.target.innerText)}>601 - General de Ley Personas Morales</Dropdown.Item>
                            <Dropdown.Item onClick={(e) => handleClientChange("billingInformation", "clientTaxRegime", e.target.innerText)}>603 - Personas Morales con Fines no Lucrativos</Dropdown.Item>
                            <Dropdown.Item onClick={(e) => handleClientChange("billingInformation", "clientTaxRegime", e.target.innerText)}>610 - Residentes en el Extranjero sin Establecimientos Permanente en México</Dropdown.Item>
                            <Dropdown.Item onClick={(e) => handleClientChange("billingInformation", "clientTaxRegime", e.target.innerText)}>620 - Sociedades Cooperativas de Producción que optan por diferir sus ingresos</Dropdown.Item>
                            <Dropdown.Item onClick={(e) => handleClientChange("billingInformation", "clientTaxRegime", e.target.innerText)}>622 - Actividades Agrícolas, Ganaderas, Silvícolas y Pesqueras</Dropdown.Item>
                            <Dropdown.Item onClick={(e) => handleClientChange("billingInformation", "clientTaxRegime", e.target.innerText)}>623 - Opcional para Grupos de Sociedades</Dropdown.Item>
                            <Dropdown.Item onClick={(e) => handleClientChange("billingInformation", "clientTaxRegime", e.target.innerText)}>624 - Coordinados</Dropdown.Item>
                            <Dropdown.Item onClick={(e) => handleClientChange("billingInformation", "clientTaxRegime", e.target.innerText)}>626 - Régimen Simplificado de Confianza</Dropdown.Item>
                        </Dropdown.Menu>
                    </Dropdown>
                </div>
                
                <div className="inputContainer">
                    <span className="label">Country</span>

                    <Dropdown>
                        <Dropdown.Toggle className={draft.billingInformation?.clientCountry ? "" : "default"}>
                            {draft.billingInformation?.clientCountry ? draft.billingInformation?.clientCountry : "Select country"}
                        </Dropdown.Toggle>

                        <Dropdown.Menu>
                            {countryInformation.map((information, index) => (
                                <Dropdown.Item key={index} onClick={(e) => handleClientChange("billingInformation", "clientCountry", e.target.innerText)}>
                                    {information.country}
                                </Dropdown.Item>
                            ))}
                        </Dropdown.Menu>
                    </Dropdown>
                </div>

                <div className="inputContainer">
                    <span className="label">
                        {countryInformation.find(c => c.country.toUpperCase() === draft.billingInformation?.clientCountry?.toUpperCase())?.typePersonLabel}
                    </span>

                    <Dropdown>
                        <Dropdown.Toggle className={draft.billingInformation?.clientTypePerson ? "" : "default"}>
                            {draft.billingInformation?.clientTypePerson ? draft.billingInformation?.clientTypePerson : "Select option"}
                        </Dropdown.Toggle>

                        <Dropdown.Menu>
                            {countryInformation.find(c => c.country.toUpperCase() === draft.billingInformation?.clientCountry?.toUpperCase())?.typePersonValues.map((person, index) => (
                                <Dropdown.Item key={index} onClick={(e) => handleClientChange("billingInformation", "clientTypePerson", e.target.innerText)}>
                                    {person}
                                </Dropdown.Item>
                            ))}
                        </Dropdown.Menu>
                    </Dropdown>
                </div>

                <div className="inputContainer">
                    <span className="label">
                        {countryInformation.find(c => c.country.toUpperCase() === draft.billingInformation?.clientCountry?.toUpperCase())?.rfcLabel}
                    </span>
                    
                    <input 
                        id="inputRfc" 
                        value={draft.billingInformation?.clientRfc}
                        onChange={(e) => {
                            const country = draft.billingInformation?.clientCountry?.toLowerCase()
                            if (country === "méxico") {
                                handleClientChange("billingInformation", "clientRfc", e.target.value)
                            } else if (country === "united states of america") {
                                handleClientChange("billingInformation", "clientRfc", e.target.value.replace(/[^\d]/g, ""))
                            }
                        }}
                        type="text"
                        placeholder={countryInformation.find(c => c.country.toUpperCase() === draft.billingInformation?.clientCountry?.toUpperCase())?.rfcPlaceholder}
                    />
                </div>

                <div className="inputContainer">
                    <span className="label">Hold Payment email</span>
                    
                    <input 
                        value={draft.billingInformation?.clientBillingEmail}
                        onChange={(e) => handleClientChange("billingInformation", "clientBillingEmail", e.target.value)}
                        type="email" placeholder="Email address"
                        onBlur={() => handleClientChange("billingInformation", "clientBillingEmail", checkTheEmailStruct(draft.billingInformation?.clientBillingEmail))}
                    />
                </div>

                <div className="inputContainer">
                    <span className="label">State</span>

                    <Dropdown>
                        <Dropdown.Toggle className={draft.billingInformation?.clientState ? "" : "default"}>
                            {draft.billingInformation?.clientState ? draft.billingInformation?.clientState : "State"}
                        </Dropdown.Toggle>

                        <Dropdown.Menu>
                            {countryInformation.find(c => c.country.toUpperCase() === draft.billingInformation?.clientCountry?.toUpperCase())?.states.map((state, index) => (
                                <Dropdown.Item key={index} onClick={(e) => handleClientChange("billingInformation", "clientState", e.target.innerText)}>
                                    {state.name}
                                </Dropdown.Item>
                            ))}
                        </Dropdown.Menu>
                    </Dropdown>
                </div>

                <div className="inputContainer">
                    <span className="label">C.P:</span>

                    <input 
                        type="text" 
                        placeholder="Postal code" 
                        value={draft.billingInformation?.clientPostalCode}
                        onChange={(e) => handleClientChange("billingInformation", "clientPostalCode", e.target.value)}
                    />
                </div>

                <div className="inputContainer">
                    <span className="label">Street, interior & exterior number</span>

                    <input 
                        type="text" 
                        placeholder="Street, interior & exterior number" 
                        value={draft.billingInformation?.clientStreetAndNumber}
                        onChange={(e) => handleClientChange("billingInformation", "clientStreetAndNumber", e.target.value)}
                    />
                </div>

                <div className="inputContainer">
                    <span className="label">Neighborhood</span>

                    <input 
                        type="text" 
                        placeholder="Neighborhood" 
                        value={draft.billingInformation?.clientNeighborhood}
                        onChange={(e) => handleClientChange("billingInformation", "clientNeighborhood", e.target.value)}
                    />
                </div>

                <div className="inputContainer">
                    <span className="label">Municipality</span>

                    <input 
                        type="text" 
                        placeholder="Municipality" 
                        value={draft.billingInformation?.clientMunicipality}
                        onChange={(e) => handleClientChange("billingInformation", "clientMunicipality", e.target.value)}
                    />
                </div>

                <div className="inputContainer">
                    <span className="label">Payment method</span>

                    <Dropdown>
                        <Dropdown.Toggle className={draft.billingInformation?.clientPaymentMethod ? "" : "default"}>
                            {draft.billingInformation?.clientPaymentMethod ? draft.billingInformation?.clientPaymentMethod : "Select option"}
                        </Dropdown.Toggle>

                        <Dropdown.Menu>
                            <Dropdown.Item onClick={(e) => handleClientChange("billingInformation", "clientPaymentMethod", e.target.innerText)}>Pago PUE</Dropdown.Item>
                            <Dropdown.Item onClick={(e) => handleClientChange("billingInformation", "clientPaymentMethod", e.target.innerText)}>Pago PPD</Dropdown.Item>
                        </Dropdown.Menu>
                    </Dropdown>
                </div>

                <div className="inputContainer">
                    <span className="label">Payment way</span>

                    <Dropdown>
                        <Dropdown.Toggle className={draft.billingInformation?.clientPaymentWay?.length > 0 ? "" : "default"}>
                            {draft.billingInformation?.clientPaymentWay?.length > 0
                                ? draft.billingInformation?.clientPaymentWay?.map(payment => payment + ", ")
                                : "Payment way"}
                        </Dropdown.Toggle>

                        <Dropdown.Menu>
                            <div className="optionCategory">
                                <input 
                                    id="cash" 
                                    type="checkbox" 
                                    value="Cash" 
                                    onClick={(e) => addPaymentWay(e.target)}
                                    defaultChecked={draft.billingInformation?.clientPaymentWay?.some(payment => payment === "CASH")}
                                />

                                <label htmlFor="cash">Cash</label>
                            </div>

                            <div className="optionCategory">
                                <input 
                                    id="wireTransfer" 
                                    type="checkbox" 
                                    value="Wire Transfer" 
                                    onClick={(e) => addPaymentWay(e.target)}
                                    defaultChecked={draft.billingInformation?.clientPaymentWay?.some(payment => payment === "WIRE TRANSFER")}
                                />

                                <label htmlFor="wireTransfer">Wire Transfer</label>
                            </div>
                        </Dropdown.Menu>
                    </Dropdown>
                </div>
                
                <div className="inputContainer">
                    <span className="label">Use of CDFI</span>

                    <Dropdown>
                        <Dropdown.Toggle className={draft.billingInformation?.clientCdfiUse ? "" : "default"}>
                            {draft.billingInformation?.clientCdfiUse ? draft.billingInformation?.clientCdfiUse : "Select option"}
                        </Dropdown.Toggle>

                        <Dropdown.Menu>
                            <Dropdown.Item onClick={(e) => handleClientChange("billingInformation", "clientCdfiUse", e.target.innerText)}>Adquisición de mercancia</Dropdown.Item>
                            <Dropdown.Item onClick={(e) => handleClientChange("billingInformation", "clientCdfiUse", e.target.innerText)}>Gastos en general</Dropdown.Item>
                        </Dropdown.Menu>
                    </Dropdown>
                </div>

                <div className="inputContainer">
                    <span className="label">Payment condition</span>

                    <input 
                        type="text" 
                        placeholder="Payment condition" 
                        value={draft.billingInformation?.clientPaymentCondition}
                        onChange={(e) => handleClientChange("billingInformation", "clientPaymentCondition", e.target.value)}
                    />
                </div>
                
                <div className="inputContainer">
                    <span className="label">Currency</span>

                    <Dropdown>
                        <Dropdown.Toggle className={draft.billingInformation?.clientCurrencies?.length > 0 ? "" : "default"}>
                            {draft.billingInformation?.clientCurrencies?.length > 0
                                ? draft.billingInformation?.clientCurrencies?.map(currency => currency + ", ")
                                : "Currency"}
                        </Dropdown.Toggle>

                        <Dropdown.Menu>
                            <div className="optionCategory">
                                <input 
                                    id="dollar" 
                                    type="checkbox" 
                                    value="Dollar" 
                                    onClick={(e) => addCurrency(e.target)}
                                    defaultChecked={draft.billingInformation?.clientCurrencies?.some(currency => currency === "DOLLAR")}
                                />

                                <label htmlFor="dollar">Dollar</label>
                            </div>
                            
                            <div className="optionCategory">
                                <input 
                                    id="pesos" 
                                    type="checkbox" 
                                    value="Pesos" 
                                    onClick={(e) => addCurrency(e.target)}
                                    defaultChecked={draft.billingInformation?.clientCurrencies?.some(currency => currency === "PESOS")}
                                />

                                <label htmlFor="pesos">Pesos</label>
                            </div>
                        </Dropdown.Menu>
                    </Dropdown>
                </div>

                <div className="inputContainer fullWidth">
                    <span className="label">Notes</span>

                    <textarea 
                        value={draft.billingInformation?.clientNotes} 
                        rows="5"
                        onChange={(e) => handleClientChange("billingInformation", "clientNotes", e.target.value)}
                    />
                </div>

                <h5 className="sectionTitle">Contact information</h5>

                <div className="inputContainer d-lg-block d-none">
                    <span className="label">Contact Name</span>
                </div>

                <div className="inputContainer d-lg-block d-none">
                    <span className="label">Email</span>
                </div>

                <div className="inputContainer d-lg-block d-none">
                    <span className="label">Phone</span>
                </div>
                
                {draft.contacts?.map((contact) => (
                    <div key={contact._id} className="contactInformationRow">
                        <div className="inputContainer">
                            <span className="label d-lg-none">Contact Name</span>

                            <input 
                                type="text" 
                                placeholder="Contact Name" 
                                value={contact.contactName}
                                onChange={(e) => handleContactInformationChange(contact._id, "contactName", e.target.value)}
                            />
                        </div>

                        <div className="inputContainer">
                            <span className="label d-lg-none">Email</span>

                            <input 
                                type="text" 
                                placeholder="Contact Email" 
                                value={contact.contactEmail}
                                onChange={(e) => handleContactInformationChange(contact._id, "contactEmail", e.target.value)}
                            />
                        </div>

                        <div className="inputContainer">
                            <span className="label d-lg-none">Phone</span>

                            <input 
                                type="text" 
                                placeholder="Contact Phone" 
                                value={contact.contactPhone}
                                onChange={(e) => handleContactInformationChange(contact._id, "contactPhone", e.target.value)}
                            />
                        </div>

                        <img className="deleteIcon" src={deleteIcon} onClick={() => handleDeleteContact(contact._id)} alt="Prodensa Supplier" />
                    </div>
                ))}
                
                <button className="btnBgBlueTextGradient addContact" onClick={handleAddContact}>Add Contact</button>
            </div>

            <h5 className="titleHeader">Multi-Entity</h5>

            <table className="entityTable">
                <thead>
                    <tr>
                        <th></th>
                        
                        <th><span>Entity</span></th>

                        <th><span>Location</span></th>
                    </tr>
                </thead>
                
                <tbody>
                    {draft.entities?.map((entity, index) => (
                        <tr key={entity._id}>
                            <td>
                                <div className="infoContainer">
                                    <span>{index + 1 < 10 ? "0" + (index + 1) : index + 1}</span>
                                </div>
                            </td>

                            <td>
                                <div className="infoContainer">
                                    <span>{!entity.entityName ? "DEFAULT ENTITY" : entity.entityName}</span>
                                </div>
                            </td>

                            <td>
                                <div className="infoContainer">
                                    <span>
                                        {!entity.entityMunicipality ? "DEFAULT MUNICIPALITY" : entity.entityMunicipality},{" "}
                                        {!entity.entityState ? "DEFAULT STATE" : entity.entityState},{" "}
                                        {draft.billingInformation?.clientCountry}
                                    </span>

                                    <img ref={moreDotsRef} className="moreDots" src={moreDots} alt="Cattenna Platform"
                                        onClick={(e) => moreDotsRef.current = e.target}
                                    />
                                    
                                    <div className="menuOptions">
                                        <span onClick={() => handleAddUserModal(entity, false)}>Add user</span>
                                        
                                        <span onClick={() => handleShowEditModal(entity)}>Edit</span>

                                        {draft.entities?.length > 1 && (
                                            <span id="deleteEntitySpan" onClick={() => handleDeleteEntities(entity._id)}>Delete</span>
                                        )}
                                    </div>
                                </div>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
            
            <div className="entityList d-lg-none">
                {draft.entities?.map((entity) => (
                    <div key={entity._id} className="entityRow">
                        <h5 className="entityName">{!entity.entityName ? "DEFAULT ENTITY" : entity.entityName}</h5>

                        <div className="entityInformation">
                            <span className="entityValue">
                                {!entity.entityMunicipality ? "DEFAULT MUNICIPALITY" : entity.entityMunicipality},{" "}
                                {!entity.entityState ? "DEFAULT STATE" : entity.entityState},{" "}
                                {draft.billingInformation?.clientCountry}
                            </span>

                            <span className="entityTitle">Location</span>

                            <img ref={moreDotsRef} className="moreDots" src={moreDots} alt="Cattenna Platform"
                                onClick={(e) => moreDotsRef.current = e.target}
                            />
                            
                            <div className="menuOptions">
                                <span onClick={() => handleAddUserModal(entity, false)}>Add user</span>

                                <span onClick={() => handleShowEditModal(entity)}>Edit</span>

                                {draft.entities?.length > 1 && (
                                    <span id="deleteEntitySpan" onClick={() => handleDeleteEntities(entity._id)}>Delete</span>
                                )}
                            </div>
                        </div>
                    </div>
                ))}
            </div>

            <button className="btnBgBlueTextGradient addEntity" onClick={() => setAddModalShow(true)}>
                Add Entity
            </button>

            <ClientDocuments entities={draft.entities} />

            <button className="btnBgBlueTextGradient addClient" disabled={isSaving} onClick={handleEditClient}>
                Save Client
            </button>

            <AddEntityModal
                show={addModalShow}
                onHide={() => setAddModalShow(false)}
                setEntities={handleSetEntities}
                country={draft.billingInformation?.clientCountry}
                companyName={draft.billingInformation?.clientCompanyName}
                rfc={draft.billingInformation?.clientRfc}
                state={draft.billingInformation?.clientState}
                postalCode={draft.billingInformation?.clientPostalCode}
                streetAndNumber={draft.billingInformation?.clientStreetAndNumber}
                neighborhood={draft.billingInformation?.clientNeighborhood}
                municipality={draft.billingInformation?.clientMunicipality}
                editView={true}
                checkEntitiesUrlName={checkEntitiesUrlName}
            />

            {entityToEdit && (
                <EditEntityModal
                    show={editModalShow}
                    onHide={() => setEditModalShow(false)}
                    entityToEdit={entityToEdit}
                    handleEntityChange={handleEditEntity}
                    country={draft.billingInformation?.clientCountry}
                    companyName={draft.billingInformation?.clientCompanyName}
                    rfc={draft.billingInformation?.clientRfc}
                    state={draft.billingInformation?.clientState}
                    postalCode={draft.billingInformation?.clientPostalCode}
                    streetAndNumber={draft.billingInformation?.clientStreetAndNumber}
                    neighborhood={draft.billingInformation?.clientNeighborhood}
                    municipality={draft.billingInformation?.clientMunicipality}
                    editView={true}
                    checkEntitiesUrlName={checkEntitiesUrlName}
                />
            )}

            <UsersControlModal
                darkLightMode={darkLightMode}
                show={usersControlModal}
                onHide={() => setUsersControlModal(false)}
                client={draft}
            />

            <MassiveUploadModal
                show={showMassiveUploadModal}
                onHide={() => setShowMassiveUploadModal(false)}
                entities={draft.entities}
            />

            <AddClientUserModal
                darkLightMode={darkLightMode}
                show={showUserModal}
                onHide={() => setShowUserModal(false)}
                client={clientToAddUser}
                isAdminClient={isAdminClient}
                havePurchasing={havePurchasing}
            />
        </section>
    )
}
